import { useEffect } from "react";
import { useHeightData } from "../../../state";
import { Cube } from "../../../state/types";
import { DEMHistogram } from "../../diagrams/DEMDiagram";
import { Info, nFormat, SubHeader } from "../util";

const hButtonClassName =
  "rounded-md w-14 flex items-center justify-center font-bold text-sm p-2 hover:bg-yellow border border-gray";
const HeightButtonBar = ({ options, selected }) => (
  <div className="flex pl-2 gap-3">
    {options.map((o, i) => (
      <button
        key={o.date}
        className={`${hButtonClassName} bg-${i === selected ? "bright-yellow" : ""}`}
      >
        {o.date.substring(0, 4)}
      </button>
    ))}
  </div>
);

const HeightStats = ({ min, max }) => (
  <div className="grid grid-cols-3 gap-4 py-3 bg-extra-light-gray">
    <div className="text-center">
      <div>Minimaal</div>
      <div className="font-bold">{nFormat.format(min)} m</div>
    </div>
    <div className="text-center">
      <div>Maximaal</div>
      <div className="font-bold">{nFormat.format(max)} m</div>
    </div>
    <div className="text-center">
      <div>Hoogteverschil</div>
      <div className="font-bold">{nFormat.format(max - min)} m</div>
    </div>
  </div>
);

export const Height = ({ field }: { field: Cube }) => {
  const heightData = useHeightData();
  useEffect(() => {
    if (heightData.gps !== field.center) {
      heightData.selectHeight(field.center);
    }
  }, [heightData, field]);

  if (heightData.state !== "fetched") {
    return heightData.state === "error" ? null : <div>Loading...</div>;
  }
  const { versions, version, stats } = heightData.data;
  return (
    <>
      <SubHeader>Hoogte</SubHeader>
      <Info className="rounded-sm border-gray border p-2 space-py-3">
        <HeightButtonBar options={versions} selected={version} />
        <HeightStats min={stats.min} max={stats.max} />
        <div>
          <DEMHistogram stats={stats} />
        </div>
      </Info>
    </>
  );
};
